import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureAccessService } from '../../../../services/framework/featureaccess.service';
import { AppToastService } from 'src/app/features/widgets/services/app-toast.service';
import { ITileOrder, TileContainerComponent } from 'src/app/features/widgets/tile-container/tile-container.component';
import { Tile } from 'src/app/features/widgets/tile/tile.component'; 
import { CacheService, StaffItem } from '../../../../services/cache.service';
import { VideoModalComponent } from '../../common/video-modal/video-modal.component';
import { CommonModule } from '@angular/common';
import { ApplicationItem } from '../models/applicationItem';
import { ApplicationsService } from '../services/application.service';
/*import { ClipboardService}from 'ngx-clipboard'*/

@Component({
  selector: 'page-app-applications',
  templateUrl: './page-applications.component.html',
  standalone: true,
  imports: [
    TileContainerComponent,
    VideoModalComponent, CommonModule
  ],
 
  styleUrls: ['./page-applications.component.scss']
})
export class PageApplicationsComponent implements OnInit {
  title!: string;
  commonItems!: CommonItems[];
  videoDetail!: any;
  applications: ApplicationItem[] = [];
  tileColor: string = "secondary2";
  tileTitle: string = "Applications";
  tiles: Tile[] = [];
  currentUser!: StaffItem;
  showPopUp: boolean = false;
  showPopup: boolean = false;
  videoType: string = "";


  constructor(private service: ApplicationsService, private router: Router, private route: ActivatedRoute, private toaster: AppToastService,  private featureaccess: FeatureAccessService) {
    this.title = "Applications";
    //this.commonService.getVideoLnks().then(data => {
    //  this.commonItems = data;
    //  //this.videoDetail = this.commonItems.filter(x => x.pageTitle == this.title)[0].videoUrl;
    //});
}

  async ngOnInit() {
    this.videoType = "Applications";
       await this.retrieveApplications();
  }
  openPopup() {
    this.showPopup = true;
  }
  copyToClipboard() { 
    const content ="Proj3ct2026!"; 
    navigator['clipboard'].writeText(content).then().catch(e => console.error(e));
    this.toaster.show("Copy to Clipboard",'password copied',5000);
}
  async retrieveApplications() {
    this.service.getAllItems()
      .subscribe(
        async data => {
          this.applications = data;
          await this.loadItems();   
          var allTiles = await this.getTiles();
          var filteredTiles : Tile[] = [];
          allTiles.forEach(async (tile) => {
            if (this.featureaccess.getAccessPermission(`/App-${tile.data.text}`)) {
              filteredTiles.push(tile);
              if (filteredTiles.length>0) {
                this.tiles = filteredTiles;
              }
            }
            else if (filteredTiles.length == 0) {
              this.tiles = await this.getTiles();
            }
          })

        },
        error => {
          console.log(error);
        });
  }

  private async loadItems() :Promise<void>{
    this.applications.forEach(async (application) => {
      application.tile = {
        color: this.tileColor,
        type: "application",
        title: this.tileTitle,
        size: "xlarge",
        id: application.id!,
        cssclass: "tilebutton",
        ispinned: false
      };
    });
  }

  activateLink(application: ApplicationItem) {
    if (application.routerLink && application.routerLink != 'NULL') {
      this.router.navigate([application.routerLink], { relativeTo: this.route });
    }
    else {
      window.open(application.actionUrl, '_blank', 'noreferrer')
      //if (application.loginRequired == ApplicationLoginRequired.PIResearch) {
      //  this.service.getPILink(this.currentUser.emailAddress, application.actionUrl).then(
      //    data => {
      //      window.open(data, '_blank', 'noreferrer');
      //    });
      //} else {
      //  window.open(application.actionUrl, '_blank', 'noreferrer')
      //}

    }
  } 

  public addTileToast(event: Tile) {
    /*this.toaster.show('Tile Pinned', 'Tile ' + event.title + ', with id: ' + event.id + ' was changed to ' + (event.ispinned ? 'pinned' : 'unpinned'), 5000);*/
    this.toaster.show('Tile Pinned', 'Tile ' + event.title  + ' was changed to ' + (event.ispinned ? 'pinned' : 'unpinned'), 5000);
    /*window.location.reload();*/
  }
  
  async getTiles(): Promise<Tile[]> {
    return this.applications.map( application => {
      var tile = application.tile;
      tile.data = application;
      return tile;
    });
  }
 
  orderChange(event: ITileOrder[]) {
  }
  closeVideoPopup(ev: any) {
    this.showPopup = false;
  }
}
export interface CommonItems {
  id: string
  pageTitle: string;
  videoUrl: string;
  isActive: boolean;
  selectQuery: any;
  selectType: any;
  loginRequired: any;
}
